export const THRIVEWORKS_HOME = '/'
export const PRIVACY_POLICY = '/privacy-policy-terms-use/'
export const CANCELLATION_POLICY_URL =
  'https://thriveworks.com/counseling-life-coaching/cancellation-policy/'
export const REQUEST_MEDICAL_RECORDS = '/medical-records-request/'

export const BBB_PROFILE_URL =
  'https://www.bbb.org/us/va/lynchburg/profile/mental-health-services/thriveworks-administrative-services-llc-0613-90017165/#sealclick'
export const BBB_SEAL_IMAGE_URL =
  'https://seal-vawest.bbb.org/logo/rbvtbul/bbb-90017165.png'

export const LEGITSCRIPT_PROFILE_URL =
  'https://www.legitscript.com/websites/?checker_keywords=thriveworks.com'
export const LEGITSCRIPT_BADGE_SRC = '/images/footer-badges/legitscript.svg'
export const SSL_SECURE_BADGE_SRC = '/images/footer-badges/ssl-secure.svg'

export const COOKIE_PREFERENCES_LABEL = 'Cookie Preferences'

export type FooterLegalHrefLink = {
  type: 'href'
  label: string
  href: string
}

export type FooterLegalActionLink = {
  type: 'action'
  label: string
  action: 'cookie-preferences'
}

export type FooterLegalLink = FooterLegalHrefLink | FooterLegalActionLink

export const footerLegalLinks: FooterLegalLink[] = [
  {
    type: 'href',
    label: 'Privacy & Terms',
    href: PRIVACY_POLICY,
  },
  {
    type: 'href',
    label: 'Request Medical records',
    href: REQUEST_MEDICAL_RECORDS,
  },
  {
    type: 'action',
    label: COOKIE_PREFERENCES_LABEL,
    action: 'cookie-preferences',
  },
]

export const quickLinks: FooterLink[] = [
  {
    label: 'Find A Counselor',
    link: '/find-counselor/',
  },
  {
    label: 'Online Counseling',
    link: '/online-counseling/#selectState',
  },
  {
    label: 'About Us',
    link: '/professional-counseling/',
  },
  {
    label: 'Free eBook',
    link: '/free-download/',
  },
  {
    label: 'Counseling Jobs',
    link: '/employment/counseling-jobs/',
  },
  {
    label: 'Franchise',
    link: '/counseling-franchise/',
  },
]

export const helpLinks: FooterLink[] = [
  {
    label: 'Addiction Counseling ',
    link: '/substance-abuse-addiction-counseling/',
  },
  {
    label: 'Anger Management',
    link: '/anger-management/',
  },
  {
    label: 'Anxiety Counseling',
    link: '/anxiety-disorder-counseling/',
  },
  {
    label: 'Career Counseling',
    link: '/career-counseling/',
  },
  {
    label: 'Child Therapy',
    link: '/child-therapy/',
  },
  {
    label: 'CBT',
    link: '/cognitive-behavioral-therapy/',
  },
  {
    label: 'Couples Counseling',
    link: '/couples-counseling/',
  },
  {
    label: 'Depression Counseling',
    link: '/depression-counseling/',
  },
  {
    label: 'Family Therapy',
    link: '/family-therapy/',
  },
  {
    label: 'Grief Counseling',
    link: '/grief-counseling/',
  },
  {
    label: 'Life Coaching',
    link: '/life-coaching/',
  },
  {
    label: 'Marriage Counseling',
    link: '/marriage-counseling/',
  },
  {
    label: 'Online Psychiatry',
    link: '/psychiatry/',
  },
  {
    label: 'Premarital Counseling',
    link: '/premarital-counseling/',
  },
  {
    label: 'Psychologists',
    link: '/psychologists/',
  },
  {
    label: 'Trauma Therapy',
    link: '/trauma-therapy/',
  },
  {
    label: 'View all Topics...',
    link: '/mental-health-topics/',
  },
]

// Interim + Redesigned footer
export const thriveworksLinks: FooterLink[] = [
  {
    label: 'About us',
    link: '/professional-counseling/',
  },
  {
    label: 'Insurance & pricing',
    link: '/pricing/',
  },
  {
    label: 'Locations',
    link: '/find-counselor/',
  },
  {
    label: 'FAQs',
    link: '/faq/',
  },
  {
    label: 'Editorial policy',
    link: '/editorial-policy/',
  },
  {
    label: 'Press',
    link: '/press/',
  },
  {
    label: 'Careers',
    link: '/careers/',
  },
  {
    label: 'Reviews',
    link: '/professional-counseling/reviews-and-testimonials/',
  },
]

export const reachUsLinks: FooterLink[] = [
  {
    label: '888-123-4567',
    link: 'tel:8881234567',
  },
  {
    label: 'Contact us',
    link: '/contact-thriveworks/',
  },
]

export const resourcesLinks: FooterLink[] = [
  {
    label: 'Free eBooks',
    link: '/free-download/',
  },
  {
    label: 'Anxiety',
    link: '/help-with/anxiety/',
  },
  {
    label: 'Depression',
    link: '/help-with/depression/',
  },
  {
    label: 'Grief & Loss',
    link: '/help-with/grief-loss/',
  },
  {
    label: 'Relationships',
    link: '/help-with/relationships/',
  },
  {
    label: 'Self-care',
    link: '/help-with/self-care/',
  },
  {
    label: 'Stress',
    link: '/help-with/stress/',
  },
  {
    label: 'All topics',
    link: '/help-with/mental-health-topics/',
  },
]

export const servicesLinks: FooterLink[] = [
  {
    label: 'Individual therapy',
    link: '/find-help/individual-therapy/',
  },
  {
    label: 'Psychiatry / medication management',
    link: '/psychiatry/',
  },
  {
    label: 'Online therapy',
    link: '/online-counseling/',
  },
  {
    label: 'Child / teen therapy',
    link: '/find-help/child-teen-therapy/',
  },
  {
    label: 'Family therapy',
    link: '/find-help/family-therapy/',
  },
  {
    label: 'Couples / marriage therapy',
    link: '/find-help/couples-marriage-therapy/',
  },
  {
    label: 'Find a therapist',
    link: '/therapists',
  },
  {
    label: 'Find a psychiatric NP',
    link: '/psychiatrists',
  },
]

export const insuranceLinks: FooterLink[] = [
  {
    label: 'Aetna',
    link: '/pricing/#insurance',
  },
  {
    label: 'Optum / UnitedHealthcare',
    link: '/pricing/#insurance',
  },
  {
    label: 'BCBS Plans',
    link: '/pricing/#insurance',
  },
  {
    label: 'Beacon Health',
    link: '/pricing/#insurance',
  },
  {
    label: 'Cigna',
    link: '/pricing/#insurance',
  },
  {
    label: 'Tricare West',
    link: '/pricing/#insurance',
  },
  {
    label: 'Humana',
    link: '/pricing/#insurance',
  },
  {
    label: 'Medicare',
    link: '/pricing/#insurance',
  },
  {
    label: 'Tufts Health Plans',
    link: '/pricing/#insurance',
  },
  {
    label: 'All insurances',
    link: '/pricing/#insurance',
  },
]

export const socialLinks: SocialLink[] = [
  { icon: 'tiktok', link: 'https://www.tiktok.com/@thriveworks' },
  { icon: 'instagram', link: 'https://www.instagram.com/thriveworks/' },
  { icon: 'facebook', link: 'https://www.facebook.com/Thriveworks' },
  { icon: 'twitter', link: 'https://twitter.com/Thriveworks' },
  {
    icon: 'youtube',
    link: 'https://www.youtube.com/c/Thriveworks',
  },
  { icon: 'linkedin', link: 'https://www.linkedin.com/company/thriveworks' },
]
